import styled from 'styled-components';

export const Icon = styled.img<{size?: number}>`
  width: ${({size}) => (size ? `${size}px` : '40px')};
  height: ${({size}) => (size ? `${size}px` : '40px')};
`;
